<breadcrumb-item-view class="back" *ngIf="showMobileBackButton && items?.length > 1">
	<button
		class="back-button icon-btn ficon-arrow-left"
		type="button"
		(click)="onBack()"
		attr.aria-label="{{'common_back'| translate}}"
	></button>
</breadcrumb-item-view>

<ng-content></ng-content>
